var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlansIcon1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.92,
    height: 25.227,
    viewBox: "0 0 18.92 25.227",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "form_2_",
    "data-name": "form (2)",
    d: "M10.358,10.511a3.153,3.153,0,1,0,0,6.307h4.2a3.153,3.153,0,0,0,0-6.307Zm5.256,3.153a1.051,1.051,0,0,1-1.051,1.051h-4.2a1.051,1.051,0,0,1,0-2.1h4.2A1.051,1.051,0,0,1,15.613,13.665Zm2.1,6.307a1.051,1.051,0,0,1-1.051,1.051H8.256a1.051,1.051,0,1,1,0-2.1h8.409A1.051,1.051,0,0,1,17.716,19.971ZM20.381,3.281,18.639,1.54A5.222,5.222,0,0,0,14.923,0H8.256A5.262,5.262,0,0,0,3,5.256V19.971a5.262,5.262,0,0,0,5.256,5.256h8.409a5.262,5.262,0,0,0,5.256-5.256V7a5.222,5.222,0,0,0-1.539-3.717ZM18.9,4.767a3.258,3.258,0,0,1,.4.489H16.665V2.628a3.082,3.082,0,0,1,.488.4Zm.923,15.2a3.153,3.153,0,0,1-3.153,3.153H8.256A3.153,3.153,0,0,1,5.1,19.971V5.256A3.153,3.153,0,0,1,8.256,2.1h6.307V5.256a2.1,2.1,0,0,0,2.1,2.1h3.153Z",
    transform: "translate(-3 0)",
    fill: "#ff643a"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlansIcon1);
export default __webpack_public_path__ + "static/media/plans-icon1.9ea23d7c2d5b7a3e39f63b22ebe1ee29.svg";
export { ForwardRef as ReactComponent };